<template>
  <div>
    <SynchronizingModal
      v-if="isSynchronizing"
      :isSynchronizing="isSynchronizing"
    />

    <MapContainer
      :pois="filteredPois"
      :id-on-hover="idOnHover"
    />

    <v-container>
      <v-alert
        v-if="error"
        dense
        outlined
        type="error"
      >
        {{ $t(error) }}
      </v-alert>

      <!-- Deactivated while there's only the venues  -->
      <!-- <CategoryToggle-->
      <!-- :categories="categories"-->
      <!--  />-->

      <v-row>
        <v-col cols="12">
          <h1>{{ title }}</h1>
          <div class="description-block" v-html="text"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <SearchContainer
            ref="search-container"
            :is-loading="isLoading"
            :is-fetching="isFetching"
            :filtered-pois="filteredPois"
            @filterPois="filterPois"
            @onHover="onHover"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { deserialize } from '../utils'

  const SynchronizingModal = () => import(/* webpackPrefetch: true */'../components/search/SynchronizingModal.vue')

  import MapContainer from '../components/map/MapContainer.vue'
  // import CategoryToggle from '../components/search/CategoryToggle.vue'
  import SearchContainer from '../components/search/SearchContainer.vue'

  export default {
    name: 'Home',

    title: 'Venue finder - Lausanne Tourisme',

    props: {
      isFetching: {
        required: true,
        type: Boolean,
      },

      isSynchronizing: {
        required: true,
        type: Boolean,
      },
    },

    components: {
      SynchronizingModal,
      MapContainer,
      // CategoryToggle,
      SearchContainer,
    },

    data() {
      return {
        isLoading: true,
        filteredPois: [],
        idOnHover: '',
      }
    },

    computed: {
      pois() {
        return this.$store.state.objects.pois
      },

      error() {
        return this.$store.state.error.objects
      },

      locale() {
        return this.$store.state.locale
      },

      categories() {
        return [
          {
            label: this.$tc('categories.venue', 2),
            value: 'venues',
          },
          {
            label: this.$tc('categories.offer', 2),
            value: 'offers',
          },
        ]
      },

      title() {
        return this.$t('search.title')
      },

      text() {
        return this.$t('search.text')
      }
    },

    methods: {
      displayPois() {
        if (this.pois.length > 0) {
          this.filteredPois = this.pois.filter((poi) => poi.business_content[this.locale])

          if (this.$route.query.query) this.applyQueryStringFilter()

          this.isLoading = false
        }
      },

      applyQueryStringFilter() {
        const queryString = window.location.href.split('?')[1]

        const filters = deserialize(queryString)

        delete filters.query

        this.$refs['search-container'].filters.venuesPanelIsOpen = true

        // Should be a test to see if slider or checkbox.
        // for checkbox, do nothing
        // for slider, do as follow for every one of them
        this.$refs['search-container'].$refs['venues-filter-panel'].filters.peopleNumber = filters.peopleNumber

        for (let group in filters) {
          const isCheckboxes = !Array.isArray(filters[group])

          // checkboxes
          if (isCheckboxes) {
            const allAreTrue = !Object.values(filters[group]).some((value) => !value)

            for (let filter in filters[group]) {
              const groupComponent = this
                .$refs['search-container']
                .$refs['venues-filter-panel']
                .$refs[group]

              if (groupComponent && !allAreTrue) {
                const filterComponent = groupComponent[0].$refs[filter]

                if (filterComponent && filters[group][filter]) {
                  filterComponent[0].$el.querySelector('input').click()
                }
              }
            }

            continue
          }

          // slider
          this
            .$refs['search-container']
            .$refs['venues-filter-panel']
            .$refs[group]
          .range = filters[group]
        }

        this.$nextTick(() =>{
          this.$refs['search-container'].scrollToResult()

          this.$refs['search-container'].$refs['venues-filter-panel'].applyFilter()
        })
      },

      async synchronize() {
        this.isLoading = true
      },

      filterPois(pois) {
        this.isLoading = true
        this.filteredPois = pois.filter((poi) => poi.business_content[this.locale])
        document.getElementById('results').scrollIntoView()

        // Timeout before displaying POIs to avoid app from jumping
        setTimeout(() => this.isLoading = false, 500)
      },

      onHover(id) {
        this.idOnHover = id
      },
    },

    mounted() {
      this.displayPois()
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"
  @import "@/assets/styles/_mixins.sass"

  .v-btn
    @include basic-btn

  .v-icon
    margin-right: 5px

  .results-number
    margin-left: 10px
    font-family: "EuclidMedium"
    color: $gray
    font-size: 14.4px
</style>

<style lang="sass">
  .description-block p
    margin-bottom: 8px
</style>
